// src/hooks/useDowntimeStatus.ts
import { shouldHideSplashScreen } from '@atoms/ValidateToken/validateTokenUtils';
import config from '@config';
import { useEffect, useState } from 'react';

export default function useDowntimeStatus(): boolean | null {
  const [isDowntime, setIsDowntime] = useState<boolean | null>(null);
  useEffect(() => {
    const checkDowntime = async () => {
      try {
        const response = await fetch(config.DOWNTIME_CHECK_URL);
        const data = await response.json();
        shouldHideSplashScreen();
        const isProd = config.ENVIRONMENT === 'production';
        const downtimeStatus = isProd ? data.prod_downtime : data.stage_downtime;

        setIsDowntime(downtimeStatus);
      } catch {
        setIsDowntime(false);
      }
    };

    checkDowntime();
  }, []);

  return isDowntime;
}
